import { ExchangeWeightCreate } from '../components/ExchangeWeight/ExchangeWeightCreate';
import { ExchangeWeightEdit } from '../components/ExchangeWeight/ExchangeWeightEdit';

export const ExchangeWeight = {
  create: ExchangeWeightCreate,
  edit: ExchangeWeightEdit,
};